// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"cW-z","inlineTitle":"dW-z","sponsoredAdsWrapper":"eW-z","marketplaceRecosWrapper":"fW-z"};